export default "__VITE_ASSET__ChPT8rmc__"